import Card from "./Card";

interface Milestone {
  label: string;
  state: string;
  icon?: string;
}

interface MilestoneTrackerProps {
  milestones: Milestone[];
  progressClass: string;
}

const MilestoneTracker = ({ milestones, progressClass }: MilestoneTrackerProps) => {
  return (
    <Card title="Project Milestones">
      <div className="milestoneTrack">
        <div className="milestoneLine" />
        <div className={`milestoneLineFill ${progressClass}`} />
        <div className="milestones">
          {milestones.map((milestone) => (
            <div className="milestone" key={milestone.label}>
              <div className={`msDot ${milestone.state}`}>{milestone.icon}</div>
              <div className={`msLabel ${milestone.state}`}>
                {milestone.label}
              </div>
            </div>
          ))}
        </div>
      </div>
    </Card>
  );
};

export default MilestoneTracker;
